<template>
  <div>
    <component
      :is="layout"
      :mode="_mode"
      :data="data"
      :methods="sharedMethods()"
    />
  </div>
</template>

<script>
import { getCourseOutlineById, updateCourseOutline } from "@/services/api/course-outline";

export default {
  props: {
    id: String,
    mode: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      data: {}
    }
  },
  components: {
    "layout-default": () => import("./layout-default.vue"),
  },
  computed: {
    layout() {
      return "layout-default"
    },
    _mode() {
      // if (this.$router.currentRoute.params.id.length > 2) {
      //   return "edit"
      // }
      return this.mode;
    }
  },
  methods: {
    async getData(id) {
      return await getCourseOutlineById(id);
    },
    async loadData() {
      const data = await this.getData(this.id);
      if (data) {
        this.data = data;
      }
    },
    sharedMethods() {
      const _this = this;
      return {
        reloadData() {
          _this.loadData();
        },
        async updateCourseOutline(newData) {
          const newCourseOutline = { ..._this.data, ...newData };
          const res = await updateCourseOutline(newCourseOutline);
          return res;
        }
      }
    }
  },
  async created() {
    await this.loadData();
  }
}
</script>
